import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchPartnerAvatar } from './search-card-avatar.component';
import { SearchEntityRatingComponent } from './search-card-rating.component';

import { Link } from '@/components/ui/link/link.component';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { SearchType } from '@/types/most-search-type';
import { professionalIsNew } from '@/utils/search/search-professional.util';
import { partnerBranchDisplayName } from '@/utils/formatters/branch';
import { getPartnerUrl } from '@/utils/partner-url.util';
import { checkLaboratorialOrVaccineSearch } from '@/app/_utils/check-laboratorial-or-vaccine-search.util';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { buildPathWithQuery } from '@/utils/persisted-params.util';

interface SearchPartnerProfileProps {
  professional: SearchPartnerData['professional'];
  partner: SearchPartnerData['partner'];
  searchType: string;
  distance: number;
  procedureSlugs?: string[];
}

export const SearchPartnerProfile = ({
  professional,
  partner,
  searchType,
  procedureSlugs = [],
}: SearchPartnerProfileProps) => {
  const isLaboratorialOrVaccineSearch = checkLaboratorialOrVaccineSearch(searchType as SearchType);
  const partnerName = partnerBranchDisplayName(partner);
  const partnerUrl = procedureSlugs.length
    ? buildPathWithQuery(getPartnerUrl(partner), { exames: procedureSlugs })
    : getPartnerUrl(partner);
  const analytics = getAnalyticsPlugin();

  const trackNameClick = () => {
    analytics.track(AnalyticsEnum.CLICK_SEARCH_RESULT_PARTNER_NAME, { partner_id: partner.id });
  };

  return (
    <div className="flex">
      <SearchPartnerAvatar professional={professional} partner={partner} searchType={searchType} />
      <div className="ml-4 block w-full">
        <Link
          prefetch={false}
          href={isLaboratorialOrVaccineSearch ? partnerUrl : `/profissionais/${professional.slug}/`}
          data-testid={isLaboratorialOrVaccineSearch
            ? DataTestIdEnum.SEARCH_CARD_PARTNER_NAME_SEARCH_PARTNER_PROFILE
            : DataTestIdEnum.SEARCH_CARD_PROFESSIONAL_NAME_SEARCH_PARTNER_PROFILE}
          className="block"
          onClick={trackNameClick}
        >
          <Typography variant={TypographyVariant.MEDIUM_SUBTITLE} className="leading-6 sm:leading-7 text-green-500 font-semibold hover:underline">
            {isLaboratorialOrVaccineSearch ? partnerName : professionalDisplayName(professional)}
          </Typography>

          <SearchEntityRatingComponent
            isNew={professional ? professionalIsNew(professional.createdAt) : false}
            rating={isLaboratorialOrVaccineSearch ? partner.facility.rating : professional.rating}
          />
        </Link>
      </div>
    </div>
  );
};
